import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = ({ errorType = "404" }) => {
  const errorMessages = {
    404: {
      title: "Page Not Found",
      description:
        "The page you're looking for doesn't exist or has been moved.",
      cta: "Return Home",
    },
    401: {
      title: "Unauthorized Access",
      description: "Please log in to access this page.",
      cta: "Go to Login",
    },
    403: {
      title: "Access Denied",
      description: "You don't have permission to view this page.",
      cta: "Return Home",
    },
    500: {
      title: "Server Error",
      description: "Something went wrong on our end. We're working to fix it.",
      cta: "Try Again",
    },
  };

  const currentError = errorMessages[errorType] || errorMessages["404"];

  return (
    <div className="min-h-screen bg-[#FCF7F3]">
      <div className="max-w-[1446px] mx-auto px-4 lg:px-[32px]">
        <div className="min-h-[calc(100vh-80px)] flex flex-col items-center justify-center py-20">
          {/* Illustration or decorative element */}
          <div className="relative w-[200px] h-[200px] mb-12">
            <div className="absolute inset-0 rounded-full bg-[#EDE3DD] opacity-60"></div>
            <div className="absolute inset-8 rounded-full bg-[#FFFFFF75] backdrop-blur-[36px] shadow-[0px_0px_16px_0px_#00000004] flex items-center justify-center">
              <span className="text-5xl font-bold text-[#22272A]">
                {errorType}
              </span>
            </div>
          </div>

          {/* Error Content */}
          <div className="text-center max-w-[520px]">
            <h1 className="text-3xl md:text-4xl font-bold text-[#22272A] mb-4">
              {currentError.title}
            </h1>
            <p className="text-lg text-[#797979] mb-8">
              {currentError.description}
            </p>

            {/* Action Button */}
            <Link
              to={"/"}
              className="inline-block px-8 py-3 rounded-[8px] bg-[#22272A] text-white text-[14px] font-medium hover:opacity-90 transition-all shadow-[0px_0px_16px_0px_#00000004]"
            >
              {currentError.cta}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
